import { markRaw } from 'vue'
import Node from '@/components/Workflows/Pages/Editor/Nodes/Node'
import NodeApproversComponent from '@/components/Workflows/Pages/Editor/Nodes/NodeApprovals/NodeApprovalsComponent.vue'
import { uuid } from '@/utils/tools'
import {
  Group,
  TreeNodeInput,
  UserGroup,
  WorkflowApproverInput,
  WorkflowInput,
} from '@/components/Workflows/Pages/Workflow/workflow'
import { NodeTypes } from '@/components/Workflows/Pages/Editor/enums'

export default class NodeApprovals extends Node {
  presetData: Record<string, Group>

  compile(): WorkflowInput {
    const base = super.compile()

    const groups: Group[] = this.vModel

    const approverInput: WorkflowApproverInput = {
      id: this.id,
      parent: this.parent?.id, // Should be an id
      children: [], // We got no children
      data: groups
        .map((g) => g.userGroup)
        .filter((ug): ug is Required<UserGroup> => ug !== null)
        .map((ug) => ug.id),
    }

    base.approvers.push(approverInput)

    return base
  }

  constructor(parent: Node, data: Group[], options?: Partial<TreeNodeInput>) {
    super({
      name: NodeTypes.NODE_APPROVALS,
      vModel: data
        .sort((a, b) => a.position - b.position)
        .map((g) => ({
          ...g,
          userGroup: {
            value: g.userGroup?.id,
            label: g.userGroup?.name,
            ...g.userGroup,
          },
        })),
      key: uuid(),
      canAddNode() {
        return false
      },
      root: false,
      children: [],
      parent,
      component: markRaw(NodeApproversComponent),
      ...options,
    })

    this.presetData = data.reduce(
      (acc, group) => ({
        ...acc,
        [group.id]: group,
      }),
      {},
    )
  }
}
